module.exports = __webpack_public_path__ + "img/cost.e0bc6944.png";